import type { CrlMeasurement, WeekPercentiles } from "@/types/pregnancy"
import { HttpClient, STATIC_ROOT } from "@/api/httpClient"

export default {
	fetalWeight() {
		return HttpClient.get<WeekPercentiles[]>(`${STATIC_ROOT}/pregnancies/fetalWeight`)
	},
	motherWeightGain() {
		return HttpClient.get<WeekPercentiles[]>(`${STATIC_ROOT}/pregnancies/motherWeightGain`)
	},
	gestationalAgeCRL() {
		return HttpClient.get<CrlMeasurement[]>(`${STATIC_ROOT}/pregnancies/gestationalAgeCRL`)
	}
}
